import React from 'react';
import cn from 'classnames';

import { useDFP } from './dfp';
import * as css from './Banner.scss';

function Banner() {
	const [params, setParams] = React.useState({ slotPath: '', slotSize: [0, 0] });
	const dfp = useDFP(params);

	React.useEffect(() => {
		setParams({
			containerId: 'div-gpt-ad-242748299-v1-app',
			slotPath: '/242748299/mako/V1_web/Glglz_V1',
			slotSize: [320, 410],
			closable: true,
		});
	}, []);

	return dfp.isClosed === false ? (
		<div className={cn(css.bannerWrap, dfp.isRendered && css.rendered)}>
			<div className={css.banner}>
				<div
					id={params.containerId}
					style={{ minWidth: `${dfp.minWidth}px`, minHeight: `${dfp.minHeight}px` }}
				></div>
			</div>
		</div>
	) : null;
}

export default Banner;
